// removed by extract-text-webpack-plugin
module.exports = {"hero":"index-module__hero___16CRc"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/company/hero/index.module.scss
// module id = 1692
// module chunks = 146